import { Project } from './Project'


export const components = {
  alternate_grid: Project
}